<template>
  <div>
    <template v-for="(input, index) in value">
      <div class="items_group" :key="index">
        <div class="remove_items">
          <button v-if="index !== 0" @click="handleRemoveArray(index)">
            <span
              ><font-awesome-icon icon="times" size="2x"></font-awesome-icon
            ></span>
          </button>
        </div>

        <atoms-input-select
          label="続柄"
          :setKey="`relationship-${index}`"
          v-model="input.relationship"
          :options="useDefine.defineObject.RELATIONSHIP_OPTION_ARRAY"
          @input-emit="handleUpdateArrayValue"
        ></atoms-input-select>

        <div class="flex-container">
          <atoms-input-text
            label="姓"
            type="text"
            inputmode="text"
            placeholder="田中"
            :required="false"
            v-model="input.lastName"
            :setKey="`lastName-${index}`"
            @input-emit="handleUpdateArrayValue"
          ></atoms-input-text>

          <atoms-input-text
            label="名"
            type="text"
            inputmode="text"
            placeholder="太郎"
            :required="false"
            v-model="input.firstName"
            :setKey="`firstName-${index}`"
            @input-emit="handleUpdateArrayValue"
          ></atoms-input-text>
        </div>

        <atoms-input-select-date
          :date="`${input.birthday}`"
          label="生年月日"
          :set-key="`birthday-${index}`"
          :propDefaultYear="new Date().getFullYear() - 5"
          :propDefaultMonth="1"
          :propDefaultDay="1"
          @input-value="handleInputValue"
        />

        <atoms-input-radio
          label="性別"
          :setKey="`gender-${index}`"
          v-model="input.gender"
          :options="useDefine.defineObject.GENDER_OPTION_ARRAY"
          @input-emit="handleUpdateArrayValue"
          :is-tap="true"
        ></atoms-input-radio>

        <atoms-input-radio
          label="健康状況"
          :setKey="`healthStatus-${index}`"
          v-model="input.healthStatus"
          :options="useDefine.defineObject.SUCKLING_OPTION_ARRAY"
          @input-emit="handleUpdateArrayValue"
          :is-tap="true"
        ></atoms-input-radio>

        <atoms-input-radio
          label="同・別居"
          v-model="input.whetherToLiveTogether"
          :setKey="`whetherToLiveTogether-${index}`"
          :options="useDefine.defineObject.WHETHERTOLIVETOGETHER_OPTION_ARRAY"
          @input-emit="handleUpdateArrayValue"
          :is-tap="true"
        ></atoms-input-radio>

        <atoms-input-radio
          label="介護者(主◎,従◯)"
          v-model="input.caregiver"
          :setKey="`caregiver-${index}`"
          :options="useDefine.defineObject.CAREGIVER_OPTION_ARRAY"
          @input-emit="handleUpdateArrayValue"
          :is-tap="true"
        ></atoms-input-radio>

        <atoms-input-radio
          label="生存確認"
          :setKey="`survival-${index}`"
          v-model="input.survival"
          :options="useDefine.defineObject.SURVIVAL_OPTION_ARRAY"
          @input-emit="handleUpdateArrayValue"
          :is-tap="true"
        ></atoms-input-radio>

        <atoms-input-textarea
          :label="`備考（連絡先、職業等）`"
          placeholder="備考（連絡先、職業等）"
          :required="false"
          v-model="input.remarks"
          :setKey="`remarks-${index}`"
          :parentKey="setArrayKey"
          @input-emit="handleUpdateArrayValue"
        ></atoms-input-textarea>
      </div>
    </template>
    <div class="add_items">
      <button @click="handleAddArray()">
        <span
          ><font-awesome-icon icon="plus-circle" size="2x"></font-awesome-icon
        ></span>
        世帯状況を追加する
      </button>
    </div>
  </div>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'
import formUtils from '@/lib/formUtils/form-utils'

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    setArrayKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentMaxIndex: 0,
      useDefine: { defineObject: defineObject },
      baseObj: {
        lastName: '',
        firstName: '',
        birthday: '',
        birthdayJapaneseCalendar: '',
        survival: '',
        gender: '',
        relationship: '',
        whetherToLiveTogether: '',
        caregiver: '',
        remarks: '',
        healthStatus: '',
      },
    }
  },
  methods: {
    handleAddArray() {
      this.currentMaxIndex++
      this.$emit('add-array', this.setArrayKey, {
        lastName: '',
        firstName: '',
        birthday: '',
        birthdayJapaneseCalendar: '',
        survival: '',
        gender: '',
        relationship: '',
        whetherToLiveTogether: '',
        caregiver: '',
        remarks: '',
        healthStatus: '',
      })
    },
    handleRemoveArray(index) {
      this.currentMaxIndex--
      this.$emit('remove-array', this.setArrayKey, index)
    },
    handleUpdateArrayValue(setKey, setValue) {
      if (setKey && setValue) {
        const setKeyArray = setKey.split('-')

        if (setKeyArray[0] === 'birthday') {
          const birthdayJapaneseCalendar = formUtils.handleSetJapaneseCalendar(
            setValue
          )
          this.$emit(
            'input-emit',
            this.setArrayKey,
            'birthdayJapaneseCalendar',
            setKeyArray[1],
            birthdayJapaneseCalendar
          )
        }

        this.$emit(
          'input-emit',
          this.setArrayKey,
          setKeyArray[0],
          setKeyArray[1],
          setValue
        )
      }
    },
    handleInputValue(value, key) {
      const setKeyArray = key.split('-')
      if (setKeyArray[0] === 'birthday') {
        const birthdayJapaneseCalendar = formUtils.handleSetJapaneseCalendar(
          value
        )
        this.$emit(
          'input-emit',
          this.setArrayKey,
          'birthdayJapaneseCalendar',
          setKeyArray[1],
          birthdayJapaneseCalendar
        )
      }
      const date = `${value.getFullYear()}-${value.getMonth() +
        1}-${value.getDate()}`
      this.$emit(
        'input-emit',
        this.setArrayKey,
        setKeyArray[0],
        setKeyArray[1],
        date
      )
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.value.length === 0) {
        this.handleAddArray()
      }
      this.value.forEach(item => {
        Object.keys(this.baseObj).forEach(key => {
          if (!item[key]) {
            item[key] = ''
          }
        })
      })
      this.currentMaxIndex = this.value.length
    })
  },
}
</script>
